import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ExerciseService } from '../../exercise.service';
import { ProblemModel } from '@generativ/much-smarter-models';
import { ProblemMultipleChoiceContainerComponent } from '../../exercise-problem/problem-mc-container/problem-multiple-choice-container.component';


@Component({
    selector: 'app-lesson-strategy-answer',
    templateUrl: './exercise-strategy-answer.component.html',
    styleUrls: ['../exercise-strategy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProblemMultipleChoiceContainerComponent]
})
export class ExerciseStrategyAnswerComponent implements OnInit {

  strategyProblem: ProblemModel;

  readyToContinue = false;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private exerciseService: ExerciseService) {
  }

  ngOnInit() {
    this.strategyProblem = this.exerciseService.getStrategyProblem();
  }

  handleNext() {
    const currentExerciseId = localStorage.getItem('currentExerciseId');
    this.readyToContinue = true;
    this.router.navigate([`../completed`], {relativeTo: this.activatedRoute});
  }
}
